import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=71aa8d0c&"
import script from "./Media.vue?vue&type=script&lang=ts&"
export * from "./Media.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports